import { getQueryParam } from "../utils/queryStringHelper";

const serverEnv = getQueryParam("serverEnv") || "qa";
const DOMAIN = getQueryParam("domain") || "slotmart";

// 환경 값 정규화: 미정의/알 수 없는 값은 'qa'로 강제
const normalizedEnv = ["dev", "qa", "rdy", "live"].includes(serverEnv)
  ? serverEnv
  : "qa";

// 베이스 URL 생성기
const buildBaseUrl = (env: string) => {
  if (env === "live") {
    return `https://igbapi.${DOMAIN}.io`;
  }
  return `https://igbapi.${env}.${DOMAIN}.io`;
};

export const getServerUrl = () => {
  return buildBaseUrl(normalizedEnv);
};

export const getSocketUrl = () => {
  return `${buildBaseUrl(normalizedEnv)}/socket/client`;
};
